import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
}
export function App({
  showTestimonials = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-cream text-ink" data-id="element-0" data-mp="3ubrhck3tkg3z">
      <main data-id="element-1" data-mp="d4nuteha5g1c">
        <Hero data-id="element-2" data-mp="d57hf8hvkslp" />
        <ProductGallery data-id="element-3" data-mp="d4xmd6hz3v95" />
        {showTestimonials && <TestimonialsStrip data-id="element-4" data-mp="d2l7513lnyzs" />}
        <PainPoints data-id="element-5" data-mp="85ully910b6z" />
        <SolutionReveal data-id="element-6" data-mp="86mfn4mz60v5" />
        <VolumesSection data-id="element-7" data-mp="864d5q9pyqes" />
        <BonusSection data-id="element-8" data-mp="83qi3hf1he78" />
        <PricingSection data-id="element-9" data-mp="3gkv17sr2xrdt" />
        <ClosingArgument data-id="element-10" data-mp="3gmfuzg5kl6am" />
        <Guarantee data-id="element-11" data-mp="3glny8208l2ir" />
        <FAQ data-id="element-12" data-mp="3gj1qo2dcin0j" />
        <FinalCTA data-id="element-13" data-mp="3bmjq7ep1tau0" />
      </main>
      <Footer data-id="element-14" data-mp="3bncorsdusu12" />
      <noscript data-id="element-15" data-mp="3bnuudfmeokln">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-16" data-mp="3bk70gfd1tw6e" />
      </noscript>
    </div>;
}